import { Button } from "../ui/button";

export function RemoteThreadSubmissionStatus(props: {
  readonly failure: string | null;
  readonly onRetry: () => void;
}) {
  return (
    <div
      role="status"
      className="mx-auto flex w-full max-w-3xl items-center gap-2 px-4 py-3 text-sm text-muted-foreground"
    >
      {props.failure ? (
        <>
          <span className="min-w-0 flex-1">Not sent. {props.failure}</span>
          <Button variant="outline" className="min-h-12" onClick={props.onRetry}>
            Retry
          </Button>
        </>
      ) : (
        <>
          <img
            src="/forge-mark.svg"
            alt=""
            aria-hidden="true"
            width={16}
            height={16}
            className="size-4 motion-safe:animate-status-pulse"
          />
          Preparing...
        </>
      )}
    </div>
  );
}
